export default __webpack_public_path__ + "static/media/landscape1.56ca051b.jpg";